import { useEffect } from "react";
import { ILocationState } from "../services/types";
import { useLocation } from "react-router-dom";
import { useAuthNavigate } from "./useAuthNavigate";
import { showNotification } from "@/components/alerts/Notifications";

export enum NotifyType {
  Profile = "profile",
  Niche = "niche",
}

const notificationTitles: Record<NotifyType, string> = {
  [NotifyType.Profile]: "Sign up to follow creators and customise your feeds",
  [NotifyType.Niche]: "Sign up to join niches and customise your feeds",
};

export const useSignUpNotify = (type: NotifyType) => {
  const location = useLocation();
  const { navigateSignUp } = useAuthNavigate();
  const title = notificationTitles[type];

  useEffect(() => {
    const locationState = location.state as ILocationState | undefined;

    if (locationState?.showSignUpWarning) {
      showNotification({
        title,
        variant: "info",
        actionButton: { title: "Sign Up", onClick: navigateSignUp },
      });
    }

    return () => {
      window.history.replaceState({}, "");
    };
  }, [location, navigateSignUp, title]);
};
